import ArrowLeftCircleIcon from 'mdi-react/ArrowLeftCircleIcon'
import ArrowLeftThickIcon from 'mdi-react/ArrowLeftThickIcon'
import ArrowRightThickIcon from 'mdi-react/ArrowRightThickIcon'
import CheckboxBlankCircleOutlineIcon from 'mdi-react/CheckboxBlankCircleOutlineIcon'
import CheckboxMarkedCircleOutlineIcon from 'mdi-react/CheckboxMarkedCircleOutlineIcon'
import RestartIcon from 'mdi-react/RestartIcon'
import TagOutlineIcon from 'mdi-react/TagOutlineIcon'

export const OnboardingNextStepIcon = ArrowRightThickIcon
export const OnboardingBackStepIcon = ArrowLeftThickIcon
export const OnboardingChangeIcon = ArrowLeftCircleIcon
export const OnboardingNotSelectedIcon = CheckboxBlankCircleOutlineIcon
export const OnboardingSelectedIcon = CheckboxMarkedCircleOutlineIcon
export const OnboardingCostIcon = TagOutlineIcon
export const OnboardingRestartIcon = RestartIcon
